"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifeClassDetail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var lifeHome_1 = require("../../model/lifeHome");
var service_1 = require("../../../library/base/service");
var LifeClassDetail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(LifeClassDetail, _super);
    function LifeClassDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '课程详情';
        _this.code = '101093';
        _this.desc = '课程详情';
        _this.requestParams = new lifeHome_1.LifeClassDetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return LifeClassDetail;
}(service_1.BaseService));
exports.LifeClassDetail = LifeClassDetail;
//# sourceMappingURL=lifeClassDetail.js.map